import { SafeEditPanel } from "../../../SafeEditPanel.js";
import type { ClientPortalApiClient } from "../../../api.js";

export function V10SafeEditSection({
  api,
  linkId,
  token,
  onActionStatus,
}: {
  readonly api: ClientPortalApiClient;
  readonly linkId: string;
  readonly token: string;
  readonly onActionStatus: (message: string | null) => void;
}) {
  return <SafeEditPanel api={api} clientLinkId={linkId} token={token} onStatus={onActionStatus} />;
}
